import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Assortment, AssortmentService, AuthService, CustomPageConfigService, CustomPageTemplateComponent, GungFlowService, News, NewsPageListConfigService, NewsService, TemplateComponent } from 'gung-standard';
import { SjoborgLoginConfigService } from '../../services/sjoborg-login-config.service';
import { first, switchMap } from 'rxjs';

@Component({
  selector: 'sjoborg-startpage-custom-page',
  templateUrl: './sjoborg-startpage-custom-page.component.html',
  styleUrl: './sjoborg-startpage-custom-page.component.scss',
  standalone: false
})
export class SjoborgStartpageCustomPageComponent extends CustomPageTemplateComponent implements OnInit {
  videoUrl: string;
  assortment: Assortment;
  newsList: News[];

  constructor(
    protected router: Router,
    protected modalService: NgbModal,
    protected gungFlowService: GungFlowService,
    protected assortmentService: AssortmentService,
    protected translateService: TranslateService,
    protected customPageConfigService: CustomPageConfigService,
    protected loginConfigService: SjoborgLoginConfigService,
    protected newsService: NewsService,
    protected authService: AuthService
  ) {
    super(
      router,
      modalService,
      gungFlowService,
      assortmentService,
      translateService,
      customPageConfigService
    );
  }

  ngOnInit(): void {
    this.videoUrl = this.loginConfigService.getVideoBackground();
    this.newsService.getShowInPageUserNews().pipe(first()).subscribe(news => this.newsList = news);
    this.authService.getCurrentUser().pipe(
      first(),
      switchMap(user => this.assortmentService.getAssortmentRecursive(user.assortment).pipe(first()))
    ).subscribe(assortment => this.assortment = assortment);
  }

  getDefaultData(): TemplateComponent {
    return {
      templateName: 'startpage',
      pageName: 'StartPage',
      elements: {}
    };
  }
}
